/*
 * Copyright (C) 2018 Spanning Cloud Apps LLC.  All rights reserved.
 */
/**
 * Service used to make webapi requests for alert events.
 */
angular.module('http.alertEvents', []).factory('httpAlertEvents', function ($http) {
  return {
    getEventsForBatch
  };

  /**
   * Returns the alert events for a batch.
   *
   * @param {number} batchId - the id of the backup batch.
   * @returns {Promise<object[]>} the promise of the list of alert events.
   */
  function getEventsForBatch(batchId) {
    return $http({
      method: 'GET',
      url: 'api/alert/events',
      params: { batchId }
    }).then(function (res) {
      return res.data;
    });
  }
});
